import { getCustomerSlug } from "@components/Dwolla";
import { ENTITY, INDIVIDUAL, JOINT, SDIRA } from "@api/services/investments/shapes/ProfileTypeEnum";

import type { Investment } from "../types";

export type ProfileInvestment = Pick<
  Investment,
  "profileType" | "profileJoint" | "profileSdira" | "profileEntity" | "investorAccountId"
>;

const getProfileId = (investment: ProfileInvestment): string => {
  const {
    investorAccountId,
    profileType,
    profileJoint,
    profileEntity,
    profileSdira,
  } = investment;

  const isIndividual = profileType === INDIVIDUAL;
  const isJoint = profileType === JOINT;
  const isEntity = profileType === ENTITY;
  const isSdira = profileType === SDIRA;

  if (isIndividual) {
    return `${investorAccountId}-${profileType}`;
  }

  if (isJoint) {
    const { jointGivenName, jointFamilyName } = profileJoint;
    const normalizedName = getCustomerSlug(`${jointGivenName}-${jointFamilyName}`);

    return `${investorAccountId}-${profileType}-${normalizedName}`;
  }

  if (isEntity) {
    const { name } = profileEntity;
    const normalizedName = getCustomerSlug(name);

    return `${investorAccountId}-${profileType}-${normalizedName}`;
  }

  if (isSdira) {
    const { accountName } = profileSdira;
    const normalizedName = getCustomerSlug(accountName);

    return `${investorAccountId}-${profileType}-${normalizedName}`;
  }

  throw new Error(`Profile type ${profileType} is not supported`);
};

export default getProfileId;
